import React, { useEffect, useState } from "react";
import HeaderNav from "../components/HeaderNav";
import { Link, useParams, useRoutes } from "react-router";
import { FetchFreeGamesListService } from "../models/ApiService";
import { Loader, ToastError, ToastSuccess } from "../global/component";
import { MdContentCopy } from "react-icons/md";
import { Analytics } from "@vercel/analytics/react";

const ViewFreeGames = () => {
  const [games, setGames] = useState([]);
  const [isLoading, setIsloading] = useState(false);
  let code = useParams().code;

  useEffect(() => {
    FetchFreeGameslist();
  }, []);

  async function FetchFreeGameslist(params) {
    setIsloading(true);
    let response = await FetchFreeGamesListService(code);
    if (response.success == true) {
      let data = response.data[0].games;
      setGames(data);
      setIsloading(false);
      window.scrollTo(0, 0);
      console.log("FreeGamesList", data);
    } else {
      ToastError(response.message);
      setIsloading(false);
    }
  }

  const RenderItems = ({ data }) => {
    return (
      <div className="mb-3 w-full flex sm:w-fit">
        {/* Game box */}
        <div className="h-fit w-screen lg:w-96 md:w-96 sm:w-96 pt-3 pb-4 my-3 border-myNormalGreen border-2 bg-white flex self-center rounded-2xl justify-between gap-3 flex-col">
          <text
            style={{
              fontSize: 20,
              color: "#016401",
              fontWeight: 700,
              textAlign: "center",
            }}
          >
            {data.home.sport_id}
          </text>
          <text
            style={{
              fontSize: 15,
              color: "#016401",
              fontWeight: 700,
              textAlign: "center",
            }}
          >
            {data.home.category_name} - {data.home.tournament_name}
          </text>
          <text
            style={{
              fontSize: 15,
              color: "black",
              fontWeight: 700,
              textAlign: "center",
            }}
          >
            {data.home.home_team} Vs {data.home.away_team}
          </text>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              gap: 20,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 3,
              }}
            >
              <text
                style={{
                  fontSize: 13,
                  color: "black",
                  fontWeight: 500,
                }}
              >
                Date:
              </text>
              <text
                style={{
                  fontSize: 13,
                  color: "#016401",
                  fontWeight: 500,
                }}
              >
                {data.home.item_utc_date.split(" ")[0]}
              </text>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 3,
              }}
            >
              <text
                style={{
                  fontSize: 13,
                  color: "black",
                  fontWeight: 500,
                }}
              >
                Time:
              </text>
              <text
                style={{
                  fontSize: 13,
                  color: "#016401",
                  fontWeight: 500,
                }}
              >
                {data.home.item_utc_date.split(" ")[1]}
              </text>
            </div>
          </div>
          <text
            style={{
              fontSize: 13,
              color: "black",
              fontWeight: 500,
              textAlign: "center",
            }}
          >
            Tip: {data.home.market_name} - {data.home.outcome_name}
          </text>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              gap: 10,
            }}
          >
            <text
              style={{
                fontSize: 13,
                color: "black",
                fontWeight: 500,
                textAlign: "center",
              }}
            >
              Booking Code:
            </text>
            <Link
              className="pointer flex gap-1 items-center bg-myLightGreen py-3 rounded-full px-5"
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 3,
                alignItems: "center",
                backgroundColor: "#DAE8DA",
                paddingVertical: 10,
                borderRadius: 50,
                paddingHorizontal: 20,
              }}
              onClick={CopyCode}
            >
              <text
                style={{
                  fontSize: 13,
                  color: "#016401",
                  fontWeight: 500,
                  textAlign: "center",
                }}
              >
                {code}
              </text>
              <MdContentCopy size={18} color="#016401" />
            </Link>
          </div>
        </div>
      </div>
    );
  };

  async function CopyCode(params) {
    try {
      await navigator.clipboard.writeText(code);
      ToastSuccess("Code Copied");
    } catch (error) {}
  }

  return (
    <>
      <Analytics />
      {isLoading ? (
        <Loader message={"loading games"} />
      ) : (
        <>
          <HeaderNav />
          <div className="flex flex-wrap bg-myLightGreen gap-5 w-full items-center py-10 justify-center px-5  ">
            {games.map((item, index) => {
              return <RenderItems key={index} data={item} />;
            })}
          </div>
        </>
      )}
    </>
  );
};

export default ViewFreeGames;
